import { createSelector } from "reselect";
import makeGetChapterEntity from "selectors/chapter/makeGetChapterEntity";
import map from "lodash/map";

const getCuepointEntities = (state) => state.story.entities.cuepoints;

export default function makeGetChapterCuepoints() {
  const getChapter = makeGetChapterEntity();
  return createSelector(
    [getChapter, getCuepointEntities],
    (chapter, cuepointEntities) =>
      map(chapter.cuepoints, (cuepoint) => cuepointEntities[cuepoint]),
  );
}
